import "./GMinecraft.scss";
import {
    ArrowRight,
    Code2,
    Globe,
    Laptop,
    Lightbulb,
    Rocket, Sparkles,
    Zap,
} from "lucide-react";
import SitePresentationWeb from "../../Components/SitePresentationWeb/SitePresentationWeb";
import logo from "../../Images/logo.png"
import {useTranslation} from "react-i18next";
import Card from "../../Components/CardGallery/CardGallery";
import {useNavigate} from "react-router-dom";
import {DiscordMember, GalleryItem} from "../../types";
import {discordUrl} from "../../Global";
import {useState} from "react";

type Developer = {
    id: string;
    name: string;
    role: string;
    avatar: string;
    url?: string;
};

type website = {
    image: string;
    name: string;
    description: string;
    color: string;
    url: string;
};


const steps = [
    {
        id: "01",
        icon: Lightbulb,
    },
    {
        id: "02",
        icon: Laptop,
    },
    {
        id: "03",
        icon: Code2,
    },
    {
        id: "04",
        icon: Rocket,
    },
];

interface GMinecraftProps {
    staff: DiscordMember[] | [];
    workGraphic: GalleryItem[];
}

export default function GMinecraft({ staff, workGraphic }: GMinecraftProps) {
    const { t } = useTranslation();

    const ourMinecraft = workGraphic.filter(item => item.type === "minecraft");

    const graphicsMinecraft = staff.filter((member) =>
        member.roles.some((role) => role.id === '1558567409202237520')
    );

    console.log(staff)

    const [maxPhoto, setMaxPhoto] = useState<number>(5);

    return (
        <section className="graphics-minecraft">
            {/* ===== HERO ===== */}

            <div className="graphics-minecraft__hero">
                <div className="graphics-minecraft__hero-container">
                    {/* Left */}
                    <div className="graphics-minecraft__hero-content">
                        <h1 className="graphics-minecraft__title">
                            {t("minecraft.title.up")}
                            <br />
                            {t("minecraft.title.down")}<span>{t("minecraft.title.bold")}</span>
                        </h1>
                        <p className="graphics-minecraft__description">
                            {t("minecraft.subtitle")}
                        </p>
                        <div className="graphics-minecraft__actions">
                            <a href={discordUrl} target="_blank" className="graphics-minecraft__button" rel="noreferrer">
                                {t("minecraft.preventive")}
                                <ArrowRight size={18} />
                            </a>
                            {workGraphic.length > 0 && (
                                <a href="#portfolio" className="graphics-minecraft__button graphics-minecraft__button--secondary">
                                    {t("minecraft.lookWorks")}
                                </a>
                            )}
                        </div>
                    </div>

                    {/*Presentation*/}
                </div>
            </div>

            {/* ===== STEP ===== */}
            <div className="graphics-minecraft__steps">
                <div className="graphics-minecraft__steps-container">
                    <header className="graphics-minecraft__steps-header">
                        <h2>{t(`minecraft.develop.title`)}</h2>
                        <p>{t(`minecraft.develop.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__steps-grid">
                        {steps.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <div className="graphics-minecraft__step" key={step.id}>
                                    <div className="graphics-minecraft__step-icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3 className="graphics-minecraft__step-title">{t(`minecraft.develop.card.${step.id}.title`)}</h3>
                                    <p className="graphics-minecraft__step-description">{t(`minecraft.develop.card.${step.id}.subtitle`)}</p>
                                    {index < steps.length - 1 && (
                                        <div className="graphics-minecraft__step-connector">
                                            <Zap size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            {graphicsMinecraft.length > 0 && (
                <div className="graphics-minecraft__team">
                <div className="graphics-minecraft__team-container">
                    <header className="graphics-minecraft__team-header">
                        <h2>{t(`minecraft.employees.title`)}</h2>
                        <p>{t(`minecraft.employees.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__team-grid">
                        {graphicsMinecraft.map((dev) => (
                            <a
                                key={dev.id}
                                target="_blank"
                                href={dev.avatar}
                                rel="noopener noreferrer"
                                className="graphics-minecraft__team-card"
                            >
                                <div className="graphics-minecraft__team-avatar">
                                    <img src={dev.avatar} alt={dev.username} />
                                    <div className={`graphics-minecraft__team-status graphics-minecraft__team-status_${dev.online}`} />
                                </div>
                                <h3>{dev.username}</h3>
                                <span>Minecraft Graphic</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            )}
            {/* ===== PORTFOLIO ===== */}
            {ourMinecraft.length > 0 && (
            <div className="graphics-minecraft__portfolio" id="portfolio">
                <div className="graphics-minecraft__portfolio-container">
                    <header className="graphics-minecraft__portfolio-header">
                        <h2>{t(`minecraft.works.title`)}</h2>
                        <p>{t(`minecraft.works.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__portfolio-grid">
                        <div className="graphics-drawings__gallery__container">
                            <div className="gallery">
                                {ourMinecraft.slice(0, maxPhoto).map((photos) => (
                                    <Card
                                        item={photos}
                                    />
                                ))}
                                {ourMinecraft.length > maxPhoto && (
                                    <div onClick={() => setMaxPhoto(ourMinecraft.length)} className="card gallery-more-card">
                                        <div className="gallery-more-card__content">
                                            <p>{t("works.graphic.other")}</p>
                                            <h1>+{ourMinecraft.length - maxPhoto}</h1>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </section>
    );
}